export const RATE_LIMIT_FUNCTIONS = [
  { value: "All", label: "All" },
  { value: "Login", label: "Login" },
  { value: "Change_Password", label: "Change Password" },
  { value: "Forgot_Password", label: "Forgot Password" },
  { value: "Update_Profile", label: "Update Profile" },
  { value: "Validate_Voucher", label: "Validate Voucher" },
  { value: "Get_Verify_Code", label: "Get Verify Code" },
  { value: "Sign_Up_Success", label: "Sign Up Success" },
  { value: "Sign_Up_Failed", label: "Sign Up Failed" },
];
